import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form/immutable'
import i18next from 'i18next'

import { formatByISO } from 'app/constants/phoneCountryCodes'
import Input from 'app/components/Input'
import { normalizePhoneBeforeInsert, removeSymbolsFromPhone } from 'helpers/parsePhone'
import { required } from 'helpers/validators'

const requiredValidation = required()

// TODO: @Serginyo90 write tests
const phoneMinLength = min => phone => {
  if (!phone) {
    return undefined
  }
  const phoneWithoutPhoneCode = removeSymbolsFromPhone(phone)
  const isInvalidPhone =
    (phone.length && !phoneWithoutPhoneCode.length) || (phoneWithoutPhoneCode && phoneWithoutPhoneCode.length < min)
  return isInvalidPhone ? i18next.t('Min characters allowed', { min }) : undefined
}

const phoneMaxLength = max => phone => {
  if (!phone) {
    return undefined
  }
  const phoneWithoutPhoneCode = removeSymbolsFromPhone(phone)
  const isInvalidPhone =
    (phone.length && !phoneWithoutPhoneCode.length) || (phoneWithoutPhoneCode && phoneWithoutPhoneCode.length > max)
  return isInvalidPhone ? i18next.t('Max characters allowed', { max }) : undefined
}

const InputPhoneNumber = ({ selectedISO, isRequired, ...rest }) => {
  const normalize = (value, previousValue) => normalizePhoneBeforeInsert(selectedISO, value, previousValue)
  const phoneObj = formatByISO[selectedISO]
  const min = phoneMinLength(phoneObj.min)
  const max = phoneMaxLength(phoneObj.max)
  const validate = [min, max]
  if (isRequired) {
    validate.push(requiredValidation)
  }
  return (
    <Field
      name="phone"
      type="tel"
      component={Input}
      normalize={normalize}
      placeholder={phoneObj.format}
      validate={validate}
      {...rest}
    />
  )
}

InputPhoneNumber.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  errorBlock: PropTypes.bool,
}

export default InputPhoneNumber
